//core
import React from "react";
import { makeStyles } from "@mui/styles";
import { Box } from "@mui/material";
import { useTheme } from "@mui/styles";
import { Theme } from "@mui/material/styles/createTheme";

interface IValue {
  value: string | number;
}

const useStyles = makeStyles({
  text: { whiteSpace: "nowrap" }
});

const FloatCurrencyColor = ({ value }: IValue) => {
  const styles = useStyles();
  const theme: Theme = useTheme();
  
  const numericValue = parseFloat(String(value));
  const textColor = numericValue > 0 ? theme.palette.success.main : numericValue < 0 ? theme.palette.error.main : theme.palette.text.secondary;

  return (
    <Box component="span" className={styles.text} sx={{ color: textColor }}>
        <strong>
            {value === null ? '—' : value}
        </strong>
    </Box>
  );
};

export default FloatCurrencyColor;
